import {useEffect, useMemo, useState} from "react";

import useApi from "./useApi.js";
import {getVisibilityConflicts} from "../pages/checksheet-builder/helpers.js";

/**
 * Field-restriction members who cannot open the checksheet under `restrictTo`.
 * When visibility is by role and a user member has no loaded role (e.g. just added in a modal),
 * looks up which facility users hold the visibility roles.
 */
const useVisibilityConflicts = (restrictTo, restrictions, facilityId) => {
  const {api} = useApi("facility-users");

  const [coveredUserIds, setCoveredUserIds] = useState(() => new Set());

  const roleNames = useMemo(
    () =>
      restrictTo?.length && !restrictTo[0]?.publicId ? restrictTo.map(({name}) => name) : [],
    [restrictTo]
  );
  const roleKey = JSON.stringify(roleNames);

  const needsLookup =
    roleNames.length > 0 &&
    !!restrictions?.some(({members}) =>
      members?.some(member => member?.publicId && !member.role?.id)
    );

  useEffect(() => {
    if (!needsLookup || !facilityId) return;

    api
      .callGet("", {
        facilityId,
        noTest: true,
        limit: "all",
        filter: JSON.stringify({Roles: JSON.parse(roleKey)})
      })
      .then(({status, data}) => {
        if (status === 200 && data) setCoveredUserIds(new Set(data.map(({publicId}) => publicId)));
      });
  }, [api, facilityId, needsLookup, roleKey]);

  return useMemo(
    () => getVisibilityConflicts(restrictTo, restrictions, coveredUserIds),
    [restrictTo, restrictions, coveredUserIds]
  );
};

export default useVisibilityConflicts;
